
import { IAnonymousPageObjectTreeService } from "./anonymous-page-object-tree";
import { PageObjectTreeService } from "../page-object-tree.service";

// TODO: AnonymousPageObjectTreeService方法实现
export abstract class AnonymousPageObjectTreeService extends PageObjectTreeService implements IAnonymousPageObjectTreeService {

    constructor() {
        super();
    }

    setAnonymous(isAnonymous: boolean, anonymousUserId?: string) {
        this.setCache("IsAnonymous", isAnonymous.toString());

        if (anonymousUserId) {
            this.setCache("AnonymousUserId", anonymousUserId);
        }
    }

}